/**
 * Mirrors the backend `users.user_type` enum exactly (see Technical Architecture
 * Document, 5.1 Identity and Access Tables). Keep in sync with backend/app/Enums/UserType.php.
 */
export const UserType = {
  Student: 'student',
  RecruiterUser: 'recruiter_user',
  RecruiterAdmin: 'recruiter_admin',
  SuperAdmin: 'super_admin',
} as const

export type UserType = (typeof UserType)[keyof typeof UserType]

export const RECRUITER_ROLES: readonly UserType[] = [
  UserType.RecruiterUser,
  UserType.RecruiterAdmin,
]

export const ADMIN_ROLES: readonly UserType[] = [UserType.RecruiterAdmin, UserType.SuperAdmin]
